import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { DeleteOutlined, DownOutlined, EditOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Dropdown, Space } from "antd";
import { RESOURCE_TYPE_TENANTS } from "./tenants";
import { RefreshButton } from "@/components/common/RefreshButton";
import { useInvalidate } from "@refinedev/core";
import { useTranslation } from "react-i18next";
import { useResourceDelete } from "@/hooks/useResourceDelete";
import { useResourceContext } from "@/layouts/ResourceContext";

const RESOURCE = RESOURCE_TYPE_TENANTS;

export const TenantsActions = () => {
  const { t } = useTranslation();
  const { state } = useResourceContext();
  const navigate = useResourceNavigate();
  const invalidate = useInvalidate();
  const { mutateAsync: deleteMutate } = useResourceDelete();

  const navigateToCreation = () => {
    navigate({ resource: RESOURCE, action: "create" });
  };

  const actionsMenu = [
    {
      key: "edit",
      label: t("actions.edit", "Edit"),
      icon: <EditOutlined />,
    },
    {
      key: "delete",
      label: t("actions.delete", "Delete"),
      icon: <DeleteOutlined />,
    },
  ];

  const onClickAction = async (action) => {
    console.log("Action clicked", action);
    switch (action.key) {
      case "edit":
        const [selectedInstance] = state.selectedResources;
        navigate({ resource: RESOURCE, action: 'edit', key: selectedInstance.name });
        break;
      case "delete":
        deleteTenant();
        break;
      default:
        console.log("Unknown action", action);
    }
  };
  
  const deleteTenant = async () => {
    const [selectedInstance] = state.selectedResources;
    await deleteMutate({
      resource: RESOURCE,
      id: selectedInstance.name,
    });
  };

  return [
    <Dropdown
      key="actions"
      menu={{ items: actionsMenu, onClick: onClickAction }}
      placement="bottom"
      arrow
    >
      <Button>
        <Space>
          {t("instances.menu.actions", "Actions")}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>,
    <Button key="launch" icon={<PlusCircleOutlined />} onClick={navigateToCreation}>
      {t("tenants.menu.create")}
    </Button>,
    <RefreshButton
      key="refresh"
      onClick={() => {
        invalidate({
          resource: RESOURCE,
          invalidates: ["list"],
        });
      }}
    />,
  ];
};
